import { FieldPath } from 'firebase/firestore';

export const createFieldPath = (key) => new FieldPath(...key.split('.'));

// NOTE: if input is a string, return a FieldPath object, used to delete an invalid field path in firebase
// if input is an object, return an array of FieldPath objects and their corresponding values
// used to sanitize the fields of the treatments tried and expandable form elements

// Example acceptable object input: { "acceptedAgreements.Phentermine/Topiramate": 1727943929925 }
// This will return an array of FieldPath objects and their corresponding values so you can spread them into a firestore update function
// Example output: [ FieldPath('acceptedAgreements.Phentermine/Topiramate'), 1727943929925 ]
export const processFieldData = (input) => {
  switch (typeof input) {
    case 'string':
      return createFieldPath(input);
    case 'object':
      if (input === null) {
        throw new Error('Invalid input type. Expected a non-null object.');
      }
      return Object.entries(input).flatMap(([key, value]) => {
        const fieldPath = createFieldPath(key);
        return [fieldPath, value];
      });
    default:
      throw new Error('Invalid input type. Expected a string or an object.');
  }
};


/**
 * Trims whitespace from all string values in a plain object.
 * Non-string values are returned unchanged. If the input is not a plain object,
 * it returns the input unchanged.
 *
 * @param {object} data - The object whose string values will be trimmed.
 * @returns {object} A new object with trimmed string values, or the original input if not an object.
 */
export const trimObjectStringValues = (data) => {
  if (typeof data !== 'object' || data === null) {
    return data;
  }
  return Object.entries(data).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: typeof value === 'string' ? value.trim() : value }),
    {}, 
  );
};
/**
 * @param {Object} params 
 * @param {string} params.word 
 * @param {number} params.count
 * @param {string} [params.pluralForm]
 * @return {string} 
 */
export const ensureCorrectPluralForm = ({ word, count, pluralForm }) => {
  if (typeof word !== 'string' || typeof count !== 'number') {
    return '';
  }

  if (pluralForm && count > 1) {
    return pluralForm;
  }

  if (count > 1) {
    return `${word}s`;
  }

  return word;
}
